import OverlappingSquaresIcon from "@/assets/colorable/overlapping_squares.svg?react";
import PlayIcon from "@/assets/colorable/play.svg?react";
import type {ContentSubmissionCarouselItemSerializer} from "@/generated/DjangoTypes";
import clsxm from "@/lib/clsxm";
import {shouldMuteVideosAtom} from "@/store/jotaiAtoms";
import type {TContentSubmission} from "@/store/types";
import {useSetAtom} from "jotai";
import {useRef, useState, type FC} from "react";
import {useHoverDirty} from "react-use";

const ContentApprovalMedia: FC<{
  carouselLength?: number;
  media: TContentSubmission | ContentSubmissionCarouselItemSerializer;
  onClick: () => void;
}> = ({carouselLength, media, onClick}) => {
  const contentContainerRef = useRef<HTMLButtonElement>(null!);
  const isContentHovered = useHoverDirty(contentContainerRef);
  const setShouldMuteVideos = useSetAtom(shouldMuteVideosAtom);
  const [isVideoReady, setIsVideoReady] = useState(false);

  return (
    <button className="relative h-45 w-25 max-w-25" ref={contentContainerRef} onClick={onClick}>
      {!!carouselLength && carouselLength > 1 && (!isContentHovered || media?.media_type === "IMAGE") && (
        <div className="absolute top-1 right-1 z-10 flex min-h-5 items-center gap-2 rounded-full bg-black/90 px-2">
          <OverlappingSquaresIcon className="size-2 text-white" />
          <span className="text-2xs font-semibold text-white">{`1/${carouselLength}`}</span>
        </div>
      )}
      {!isContentHovered && media?.media_type === "VIDEO" && (
        <>
          <div className="absolute inset-0 z-10 flex items-center justify-center">
            <div className="flex size-12 items-center justify-center rounded-full border border-black/80 bg-black/60">
              <PlayIcon className="h-4.5 w-3.5 text-white" />
            </div>
          </div>
          {!!media?.video_length && (
            <span className="text-2xs absolute right-1 bottom-1 z-10 flex h-5 items-center rounded-full border border-black/80 bg-black/60 px-1.5 leading-3.5 font-semibold text-white">
              {media?.video_length}
            </span>
          )}
        </>
      )}
      <img draggable={false} src={media?.thumbnail_file!} className="h-full w-25 max-w-25 rounded-sm object-cover" />
      {isContentHovered && media?.media_type === "VIDEO" && (
        <video
          autoPlay
          className={clsxm(
            "absolute inset-0 h-full w-25 max-w-25 rounded-sm object-cover opacity-0 transition-opacity duration-150",
            isVideoReady && "opacity-100",
          )}
          controls
          controlsList="nodownload"
          draggable={false}
          loop
          onCanPlay={() => setIsVideoReady(true)}
          playsInline
          muted
          src={media?.media_file}
          onVolumeChange={e => setShouldMuteVideos(e.currentTarget.muted || e.currentTarget.volume === 0)}
        />
      )}
    </button>
  );
};

export default ContentApprovalMedia;
